;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '@workspace/ui/lib';
import { parseAsArrayOf, parseAsInteger, parseAsIsoDate, parseAsString } from 'nuqs';

const MIN_TRANSACTIONS_PAGE_SIZE = 1;
const MAX_TRANSACTIONS_PAGE_SIZE = Math.max(...DEFAULT_PAGE_SIZE_OPTIONS);
const ALLOWED_TRANSACTIONS_PAGE_SIZES: ReadonlySet<number> = new Set(DEFAULT_PAGE_SIZE_OPTIONS);

export const transactionsTableParsers = {
  transactionsSearch: parseAsString.withDefault(''),
  transactionsTransferTypes: parseAsArrayOf(parseAsString).withDefault([]),
  transactionsTeamMembers: parseAsArrayOf(parseAsString).withDefault([]),
  transactionsSources: parseAsArrayOf(parseAsString).withDefault([]),
  transactionsStatuses: parseAsArrayOf(parseAsString).withDefault([]),
  transactionsCurrency: parseAsString.withDefault(''),
  transactionsDateFrom: parseAsIsoDate,
  transactionsDateTo: parseAsIsoDate,
  transactionsPageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
};

/** Clamp page size before API use (defense in depth if URL bypasses the parser). */
export function clampTransactionsPageSize(pageSize: number): number {
  if (
    !Number.isFinite(pageSize) ||
    !Number.isInteger(pageSize) ||
    pageSize < MIN_TRANSACTIONS_PAGE_SIZE
  ) {
    return DEFAULT_PAGE_SIZE;
  }
  if (ALLOWED_TRANSACTIONS_PAGE_SIZES.has(pageSize)) return pageSize;
  if (pageSize > MAX_TRANSACTIONS_PAGE_SIZE) return MAX_TRANSACTIONS_PAGE_SIZE;
  return DEFAULT_PAGE_SIZE;
}
